import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../../theme/mediaQueriesTemplates";
import animate from "../../utils/animations";
import zIndexTypes from "../../../theme/zIndexTypes";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  ${animate("fadeIn", 0.3, 0)};

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: 420px;
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${animate("fadeInDown", 0.3, 0.15)};

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: 740px;
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
    width: calc(100vw - 20px);
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #673490;
    }
  }
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  margin: 20px 0 0 0;
  text-align: justify;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.phone} {
    margin: 10px 0 0 0;
  }
`;

export const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 55px);

  ${mediaMaxWidth.tablet} {
    padding: 0 10px;
  }
`;

export const ParagraphsWrapper = styled.div`
  max-width: 510px;
`;

interface IParagraphProps {
  center?: boolean;
}

export const Paragraph = styled.p`
  margin: 30px 0;
  text-align: ${(props: IParagraphProps) => props.center && "center"};
  font-size: 1em;

  ${mediaMaxWidth.phone} {
    font-size: 0.9em;
    margin: 20px 0;
  }
`;

export const LinkToReviews = styled.a`
  &:hover {
    color: #673490 !important;
  }
`;
